<template>
  <footer class="bg-primary">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-12">
          <img
            class="footer-logo"
            src="/img/brand/artgrab-logo-white.png"
            alt="Art Grab"
          />
          <p class="description">
            Your source for premium graphic art from leading artists.
            Exclusively license and easily download graphics. They will be yours
            forever.
          </p>
        </div>
        <div class="col-md-6 col-12 footer-link-container">
          <div class="footer-links">
            <div>
              <strong>COMPANY</strong>
              <ul>
                <li>
                  <router-link to="/about">About</router-link>
                </li>
                <li>
                  <router-link to="/privacy-policy">Privacy Policy</router-link>
                </li>
                <li>
                  <router-link to="/terms">Terms of Service</router-link>
                </li>
                <li>
                  <router-link to="/artistagreement"
                    >Artist Agreement</router-link
                  >
                </li>
                <li>
                  <router-link to="/contact">Contact</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="footer-links">
            <div>
              <strong>ARTWORK</strong>
              <ul>
                <li>
                  <router-link to="/products" @click.native="resetSearch"
                    >Products</router-link
                  >
                </li>
                <li>
                  <router-link to="/uses">Uses</router-link>
                </li>
                <li>
                  <router-link to="/store" @click.native="resetSearch"
                    >Buy Art</router-link
                  >
                </li>
                <li>
                  <router-link to="/sell">Sell Art</router-link>
                </li>
                <li>
                  <router-link to="/about">FAQ</router-link>
                </li>
                <!-- <li>
                  <router-link to="/license">Licensing Terms</router-link>
                </li>-->
              </ul>
            </div>
          </div>
          <div class="footer-links social-links">
            <div class="social-wrapper">
              <strong class="d-none d-sm-block">SOCIAL</strong>
              <ul>
                <li>
                  <router-link to="/blog">Blog</router-link>
                </li>
                <li>
                  <a href="https://instagram.com/artgrab.co" target="_blank">
                    <i class="fab fa-instagram"></i>Instagram
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/artgrab.co" target="_blank">
                    <i class="fab fa-facebook"></i>Facebook
                  </a>
                </li>
                <li>
                  <a href="https://x.com/ArtgrabCo" target="_blank">
                    <i class="fab fa-x-twitter"></i>X
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row copyright-container">
        <div class="col-md-6 col-12 mb-2 copyright d-flex">
          © {{ new Date().getFullYear() }} Art Grab, LLC. Some rights reserved.
        </div>
        <div class="col-md-6 col-12 mb-2 payment-icons">
          <div class="powered-by-stripe mb-2"><stripe-logo /></div>
          <div class="d-flex flex-row">
            <!-- <i class="fa-brands fa-apple-pay"></i>
            <i class="fa-brands fa-google-pay"></i> -->
            <i class="fab fa-cc-visa"></i>
            <i class="fab fa-cc-mastercard"></i>
            <i class="fab fa-cc-discover"></i>
            <i class="fab fa-cc-amex"></i>
            <!-- <i class="fa-brands fa-cc-paypal"></i> -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
import StripeLogo from "./StripeLogo.vue";

export default {
  name: "site-footer",
  computed: {
    ...mapState(["referral"]),
  },
  methods: {
    resetSearch() {
      this.$store.commit("setSearchPage", 1);
    },
  },
  components: {
    StripeLogo,
  },
};
</script>

<style scoped lang="scss">
footer {
  padding-top: 6rem;
  color: white;

  .description {
    width: 22rem;
    font-size: 0.875rem;
  }

  .payment-icons {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    i {
      &:not(:first-child) {
        padding-left: 0.75rem;
      }
      font-size: 1.75rem;
    }
  }

  .copyright {
    font-size: 0.75rem;
    align-items: flex-end;
  }

  .copyright-container {
    margin-top: 4.5rem;
  }

  .footer-logo {
    height: 35px;
  }

  .footer-link-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .powered-by-stripe {
    width: 120px;
    svg {
      fill: white;
    }
  }

  .footer-links {
    display: flex;
    justify-content: flex-end;
    padding-left: 4rem;

    ul {
      list-style: none;
      padding: 0;
      margin-top: 1rem;

      li {
        font-size: 0.875rem;
        margin-bottom: 0.25rem;
        a {
          color: white;
          &:hover {
            color: #11cdef;
          }
        }

        i {
          margin-right: 0.35rem;
        }
      }
    }
  }
}

@media (max-width: 991.98px) {
  footer {
    .description {
      width: 16rem;
    }

    .footer-links {
      padding-left: 2rem;

      i {
        display: block;
      }
    }
  }
}

@media (max-width: 575.98px) {
  footer {
    padding-top: 4rem;
    text-align: center;

    .description {
      padding: 0 1.5rem;
      margin-top: 0.5rem;
      width: auto;
    }

    .footer-link-container {
      flex-wrap: wrap;
      justify-content: center;
    }

    .footer-links {
      margin-top: 1.5rem;
      flex: 1;
      padding: 0 1.5rem;
      justify-content: center;

      &.social-links {
        .social-wrapper {
          width: 100%;
        }
        ul {
          display: flex;
          justify-content: space-around;

          li {
            display: inline;
          }
        }
      }
    }

    .copyright,
    .payment-icons {
      justify-content: center;
      align-items: center;
    }

    .copyright-container {
      margin-top: 2.5rem;
      flex-direction: column-reverse;
    }
  }
}
</style>
